{
  "Accessibility menu": "Tilgjengelighetsmeny",
  "Reset settings": "Tilbakestill innstillinger",
  "Close": "Lukk",
  "Content adjustments": "Innholdsjusteringer",
  "Navigation adjustments": "Navigasjonsjusteringer",
  "Align Left": "Venstrejuster",
  "Adjust Font Size": "Juster tekststørrelse",
  "Highlight Title": "Fremhev tittel",
  "Highlight Links": "Fremhev lenker",
  "Readable Font": "Lesbar skrift",
  "Colour adjustments": "Fargejusteringer",
  "Dark Contrast": "Mørk kontrast",
  "Light Contrast": "Lys kontrast",
  "High Contrast": "Høy kontrast",
  "High Saturation": "Høy metning",
  "Low Saturation": "Lav metning",
  "Monochrome": "Monokrom",
  "Tools": "Verktøy",
  "Reading Guide": "Leseguide",
  "Stop Animations": "Stopp animasjoner",
  "Big Cursor": "Stor markør",
  "Increase Font Size": "Øk tekststørrelse",
  "Decrease Font Size": "Reduser tekststørrelse",
  "Letter Spacing": "Bokstavavstand",
  "Line Height": "Linjehøyde",
  "Font Weight": "Skriftvekt",
  "Dyslexia Font": "Dysleksiskrift",
  "Language": "Språk",
  "Accessibility widget": "Åpne tilgjengelighetsmeny",
  "Accessibility Profiles": "Tilgjengelighetsprofiler",
  "Cognitive Disability": "Kognitiv funksjonshemming",
  "Seizure Safe": "Anfallssikker",
  "Accessibility statement": "Tilgjengelighetserklæring"
}
